import React from "react";

const WalletNoticeModal = ({ notice, onClose }) => {
  if (!notice?.message) return null;

  const isSuccess = notice.type === "success";

  return (
    <div className="wallet-alert-backdrop" role="alertdialog" aria-modal="true">
      <div className={`wallet-alert-panel ${isSuccess ? "is-success" : "is-error"}`}>
        <span className="wallet-alert-icon" aria-hidden="true">
          {isSuccess ? (
            <svg viewBox="0 0 24 24">
              <path d="M5 12.5 9.2 17 19 7" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24">
              <path d="M12 7v6" />
              <path d="M12 17h.01" />
            </svg>
          )}
        </span>
        <strong>{isSuccess ? "처리 완료" : "확인 필요"}</strong>
        <p>{notice.message}</p>
        <button type="button" onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  );
};

export default WalletNoticeModal;
